// @flow

import { observer } from "mobx-react";
import React from "react";
import ResizeObserver from 'react-resize-observer';

import Twemoji from "react-twemoji";

import TextExtractor from "app/util/TextExtractor";

import "./ShortComment.scss";

type Props = {
    itemId: number,
    comment: ?string,
    length?: number,
    onReadMore: ?Function
};

type State = {
    shortened: boolean,
    shouldShowReadMore: boolean
};

@observer
export default class ShortComment extends React.Component<Props, State> {
    length: number;
    elementRef: ?HTMLElement;

    constructor(props: Props) {
        super(props);

        this.state = { shortened: true, shouldShowReadMore: false };
    }

    get comment(): ?string {
        let comment = this.props.comment;
        if (!comment) return null;

        comment = TextExtractor.linkify(
            comment,
            "/content/clickthrough/" + this.props.itemId + "/"
        );
        comment = TextExtractor.breakLines(comment);

        return comment;
    }

    handleReadMore(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ shortened: false });
        if(this.props.onReadMore) {
            this.props.onReadMore();
        }
    }

    handleResize() {
        if(!this.elementRef) {
            return;
        }

        this.setState({shouldShowReadMore: this.elementRef.scrollHeight > this.elementRef.clientHeight});
    }

    setElementRef = (elementRef: ?HTMLElement) => {
        this.elementRef = elementRef;
        this.handleResize();
    }

    render() {
        if (!this.comment) return null;

        let classes = "ShortComment";
        if (this.state.shortened) {
            classes += " ShortComment--shortened";
        }

        return (
            <div className={classes} ref={this.setElementRef}>
                <ResizeObserver onResize={this.handleResize} />
                <Twemoji>
                    <div
                        className="ShortComment__text"
                        dangerouslySetInnerHTML={{ __html: this.comment }}
                    />
                </Twemoji>
                {this.renderReadMore()}
            </div>
        );
    }

    renderReadMore() {
        if (!this.state.shouldShowReadMore) return null;

        return (
            <button
                type="button"
                className="ShortComment__readMore"
                onClick={this.handleReadMore.bind(this)}
            >
                Read More
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ShortComment/ShortComment.js